import { render, staticRenderFns } from "./ticket-order-list.vue?vue&type=template&id=b4275ab8&scoped=true"
import script from "./ticket-order-list.vue?vue&type=script&lang=js"
export * from "./ticket-order-list.vue?vue&type=script&lang=js"
import style0 from "./ticket-order-list.vue?vue&type=style&index=0&id=b4275ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4275ab8",
  null
  
)

export default component.exports